import React from 'react'
import PropTypes from 'prop-types'
import styled, { ThemeConsumer } from 'styled-components'
import QRC from 'qrcode.react'
import zIndexScale from '../../utils/zIndexScale'

const QrcodeBox = styled.div`
  background: ${({ bg }) => bg || '#fff'};
  border: 2px solid #f0b90b;
  position: relative;
  padding: ${({ padding }) => `${padding}px`};
  display: inline-block;

  :after {
    content: ' ';
    display: block;
    width: ${({ size }) => `${size}px`};
    height: ${({ size, padding }) => `${size + padding * 2 + 6}px`};
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: ${({ bg }) => bg || '#fff'};
  }
  :before {
    content: ' ';
    display: block;
    width: ${({ size, padding }) => `${size + padding * 2 + 6}px`};
    height: ${({ size }) => `${size}px`};
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: ${({ bg }) => bg || '#fff'};
  }
  > canvas {
    display: block;
    position: relative;
    z-index: ${zIndexScale.normalZIndex};
  }
`

const QRCode = ({ value, size, padding }) => (
  <ThemeConsumer>
    {theme => (
      <QrcodeBox size={size} padding={padding} className="qrcode-box" bg={theme.qrcodeBg}>
        <QRC value={value || ''} size={size} level="M" includeMargin={true} />
      </QrcodeBox>
    )}
  </ThemeConsumer>
)

QRCode.propTypes = {
  value: PropTypes.string,
  background: PropTypes.string,
  size: PropTypes.number,
  padding: PropTypes.number,
}

QRCode.defaultProps = {
  value: '',
  background: '#fff',
  size: 128,
  padding: 10,
}

export default QRCode
